"use client";

import {
  GoogleTagManager,
  sendGTMEvent as gtmEvent,
} from "@next/third-parties/google";
import {
  AnalyticsActions,
  AnalyticsCategories,
  AnalyticsEventType,
  AnalyticsLabels,
} from "@/constants/analytics";
import { useAnalyticsState } from "@/utils/hooks/use-analytics-state";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

export default function TagManagerWrapper() {
  const { analyticsCookie } = useAnalyticsState();
  const pathname = usePathname();
  useEffect(() => {
    gtmEvent({
      event: "pageview",
      pagePath: pathname,
      page_path: pathname,
      page_location: pathname,
    });
  }, [pathname]);
  return analyticsCookie?.isStatisticsOn ? (
    <GoogleTagManager gtmId="GTM-WGSMGBH" />
  ) : null;
}

export function sendGTMEvent(
  event: AnalyticsEventType,
  category: AnalyticsCategories,
  label: AnalyticsLabels,
  action: AnalyticsActions,
  values?: Record<string, string>,
) {
  gtmEvent({
    event,
    category,
    action,
    label,
    ...values,
  });
}
